"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const encoding_1 = require("@iov/encoding");
const encodings_1 = require("../encodings");
const jsonrpc_1 = require("../jsonrpc");
const requests = __importStar(require("../requests"));
function encodeHeightParam(param) {
    return {
        height: encodings_1.may(encodings_1.Integer.encode, param.height),
    };
}
function encodeBlockchainRequestParams(param) {
    return {
        minHeight: encodings_1.may(encodings_1.Integer.encode, param.minHeight),
        maxHeight: encodings_1.may(encodings_1.Integer.encode, param.maxHeight),
    };
}
function encodeAbciQueryParams(params) {
    return {
        path: encodings_1.assertNotEmpty(params.path),
        data: encoding_1.toHex(params.data),
        height: encodings_1.may(encodings_1.Integer.encode, params.height),
        prove: params.prove,
    };
}
function encodeBroadcastTxParams(params) {
    return {
        tx: encodings_1.Base64.encode(encodings_1.assertNotEmpty(params.tx)),
    };
}
function encodeTxParams(params) {
    return {
        hash: encodings_1.Base64.encode(encodings_1.assertNotEmpty(params.hash)),
        prove: params.prove,
    };
}
function encodeTxSearchParams(params) {
    return {
        query: params.query,
        prove: params.prove,
        page: encodings_1.may(encodings_1.Integer.encode, params.page),
        // eslint-disable-next-line @typescript-eslint/camelcase
        per_page: encodings_1.may(encodings_1.Integer.encode, params.per_page),
    };
}
class Params {
    static encodeAbciInfo(req) {
        return jsonrpc_1.createJsonRpcRequest(req.method);
    }
    static encodeAbciQuery(req) {
        return jsonrpc_1.createJsonRpcRequest(req.method, encodeAbciQueryParams(req.params));
    }
    static encodeBlock(req) {
        return jsonrpc_1.createJsonRpcRequest(req.method, encodeHeightParam(req.params));
    }
    static encodeBlockchain(req) {
        return jsonrpc_1.createJsonRpcRequest(req.method, encodeBlockchainRequestParams(req.params));
    }
    static encodeBlockResults(req) {
        return jsonrpc_1.createJsonRpcRequest(req.method, encodeHeightParam(req.params));
    }
    static encodeBroadcastTx(req) {
        return jsonrpc_1.createJsonRpcRequest(req.method, encodeBroadcastTxParams(req.params));
    }
    static encodeCommit(req) {
        return jsonrpc_1.createJsonRpcRequest(req.method, encodeHeightParam(req.params));
    }
    static encodeGenesis(req) {
        return jsonrpc_1.createJsonRpcRequest(req.method);
    }
    static encodeHealth(req) {
        return jsonrpc_1.createJsonRpcRequest(req.method);
    }
    static encodeStatus(req) {
        return jsonrpc_1.createJsonRpcRequest(req.method);
    }
    static encodeSubscribe(req) {
        const eventTag = { key: "tm.event", value: req.query.type };
        const query = requests.buildQuery({ tags: [eventTag], raw: req.query.raw });
        return jsonrpc_1.createJsonRpcRequest("subscribe", { query: query });
    }
    static encodeTx(req) {
        return jsonrpc_1.createJsonRpcRequest(req.method, encodeTxParams(req.params));
    }
    // TODO: encode params for query string???
    static encodeTxSearch(req) {
        return jsonrpc_1.createJsonRpcRequest(req.method, encodeTxSearchParams(req.params));
    }
    static encodeValidators(req) {
        return jsonrpc_1.createJsonRpcRequest(req.method, encodeHeightParam(req.params));
    }
}
exports.Params = Params;
//# sourceMappingURL=requests.js.map